import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { debounceTime } from 'rxjs';
import { BaseComponent, ConfigurationService, LoggerService, SecurityService } from 'saker-core';

import { ProjectDTO } from 'src/app/Protocol/project.dto';
import { ProjectService } from 'src/app/Service/project.service';
import { ProjectScenarioService } from 'src/app/Service/project-scenario.service';

@Component({
  selector: 'app-project-scenario-import',
  templateUrl: './project-scenario-import.component.html',
  styleUrls: ['./project-scenario-import.component.css']
})
export class ProjectScenarioImportComponent extends BaseComponent implements OnInit {

  constructor(
    security: SecurityService,
    configuration: ConfigurationService,
    logger: LoggerService,
    router: Router,
    modal: NgbModal,
    changeDetectorRef: ChangeDetectorRef,
    private projectService: ProjectService,
    private projectScenarioService: ProjectScenarioService,
    private activatedRoute: ActivatedRoute
  ) {
    super(security, configuration, logger, router, modal, changeDetectorRef);
  }

  project: ProjectDTO | null = null;
  mnemonic: string = "";
  file: any;
  fileTypeOk: boolean = false;
  fileTypeErrorMessage: string = "";
  fileTypesAllowed: string[] = ['zip'];


  showScenarioList() {
    if (this.project)
      this.router.navigate(["projectScenarios/" + this.project.mnemonic])
  }

  submit() {
    this.logger.information('Project scenario import beginning.');

    this.projectScenarioService.importProjectScenario(this.mnemonic, this.file).subscribe(x => {
      this.logger.success('Project scenario uploaded.');
    });
  }

  onFileSelected(event: any) {
    if (event.target.files.length > 0) {
  
      this.file = event.target.files[0];

      var fType = this.file.name.slice(-3);

      if (this.fileTypesAllowed.includes(fType)) {
        this.fileTypeOk = true;
        this.fileTypeErrorMessage = "";
      }
      else {
        this.fileTypeOk = false;
        this.fileTypeErrorMessage = "Invalid file type";
      }

    }
  }
  

  private storeProject(data: ProjectDTO) {
    this.project = data;
  }

  private getProject() {

    return this.projectService.getProject(this.mnemonic)
      .subscribe((data) => { this.storeProject(data) })

  }

  private activate() {

    this.activatedRoute.paramMap.subscribe((params: any) => {
      this.mnemonic = params.params.mnemonic
    });

    this.getProject();
  }

  ngOnInit(): void {
    this.activate()
  }
}
